// 규정 전문 본문 렌더러 — 줄바꿈을 그대로 살리고, 소제목 줄은 굵게 강조한다.

interface RuleBodyProps {
  content: string;
}

// «1. 목적 및 강령», «제1조 정의», «부칙» 처럼 소제목으로 보이는 줄인지 판단한다.
function isHeading(line: string): boolean {
  const t = line.trim();
  if (!t) return false;
  if (/^제\s*\d+\s*조/.test(t)) return true;
  if (/^\d+\s*[.)]\s*\S/.test(t)) return true;
  if (/^(부칙|附則)/.test(t)) return true;
  return false;
}

export default function RuleBody({ content }: RuleBodyProps) {
  const lines = String(content ?? "")
    .replace(/\r\n/g, "\n")
    .split("\n");

  return (
    <div className="max-w-3xl whitespace-pre-wrap break-words text-[15px] leading-[1.9] text-foreground-800 md:text-base">
      {lines.map((line, i) => {
        if (!line.trim()) {
          // 빈 줄 → 문단 사이 여백
          return <span key={i} className="block h-4" aria-hidden="true" />;
        }
        if (isHeading(line)) {
          return (
            <p
              key={i}
              className="mb-2 mt-7 font-heading text-base font-bold text-foreground-950 first:mt-0 md:text-lg"
            >
              {line}
            </p>
          );
        }
        return (
          <p key={i} className="my-0">
            {line}
          </p>
        );
      })}
    </div>
  );
}